import PropTypes from "prop-types";

const optionsType = PropTypes.arrayOf(
  PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      isDivider: PropTypes.bool,
    }),
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
      group: PropTypes.string,
    }),
  ])
);

const groupsType = PropTypes.arrayOf(
  PropTypes.shape({
    value: PropTypes.string,
    title: PropTypes.string,
  })
);

export const selectPropTypes = {
  id: PropTypes.string,
  options: optionsType,
  onChange: PropTypes.func,
  isError: PropTypes.bool,
  helperText: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  renderValue: PropTypes.func,
  defaultValue: PropTypes.string,
  isDisabled: PropTypes.bool,
  isViewMode: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  isMultiple: PropTypes.bool,
  placeholder: PropTypes.string,
  groups: groupsType,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    ),
  ]),
  isLoading: PropTypes.bool,
  itemRenderer: PropTypes.func,
  className: PropTypes.string,
  classNames: PropTypes.shape({
    label: PropTypes.string,
    placeholder: PropTypes.string,
    select: PropTypes.string,
    helper: PropTypes.string,
  }),
};

export const multiSelectPropTypes = {
  ...selectPropTypes,
  allSelectedLabel: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.string),
};
